import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, HomeIcon, BotIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const steps = [{
  icon: ZapIcon,
  title: 'Scarica subito',
  text: 'Completa l’acquisto e ottieni accesso immediato a tutte le oltre 100 guide PDF passo dopo passo — senza attese e senza spedizione.',
  tone: 'bg-sky-light text-sky',
  numberTone: 'bg-sky'
}, {
  icon: HomeIcon,
  title: 'Raccogli materiali semplici',
  text: 'Ogni progetto utilizza oggetti di uso quotidiano che hai già in casa — cartone, nastro adesivo, elastici e tappi di bottiglia. Nessun acquisto speciale necessario.',
  tone: 'bg-sunshine-light text-ink',
  numberTone: 'bg-sunshine text-ink'
}, {
  icon: BotIcon,
  title: 'Costruite e imparate insieme',
  text: 'Segui la guida illustrata con tuo figlio e guardalo creare veri robot funzionanti — e brillare di orgoglio.',
  tone: 'bg-coral-light text-coral',
  numberTone: 'bg-coral text-ink'
}];
export function HowItWorks() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-96" data-mp="2rjbhh468ckmx">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-97" data-mp="2mnw5khrs8yt5">
        <SectionHeading eyebrow="Come funziona" title={<>Dal download al primo robot in 3 semplici passi</>} subtitle="Nessuna conoscenza tecnica, nessun attrezzo speciale o materiale costoso. Scarica, raccogli qualche oggetto di casa e inizia." data-id="element-98" data-mp="31b7hwlvsgmub" />
        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-99" data-mp="3ae078jleuohi">
          {steps.map((s, i) => <motion.div key={s.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative rounded-3xl border border-ink/10 bg-white p-8" data-id="element-100" data-mp="36cwtq3qu54jg" data-mpi={i}>
              <span className={`absolute -top-4 left-8 flex h-9 w-9 items-center justify-center rounded-full font-display text-lg font-bold ${s.numberTone}`} data-id="element-101" data-mp="3pzldx43k2mnm">
                {i + 1}
              </span>
              <span className={`flex h-14 w-14 items-center justify-center rounded-2xl ${s.tone}`} data-id="element-102" data-mp="2ux8b4irtu8d">
                <s.icon className="h-7 w-7" aria-hidden="true" data-id="element-103" data-mp="7s5pb1s6ns81" />
              </span>
              <h3 className="mt-5 font-display text-xl font-bold text-ink" data-id="element-104" data-mp="cr8inoyswa06">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60" data-id="element-105" data-mp="hk1ranxe42hj">
                {s.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}